import React, { useEffect, useState } from 'react'
import CustomTable from '../../../components/Table/CustomTable'
import { FaEllipsisH, FaPlusCircle } from 'react-icons/fa'
import { Button, Datepicker, Dropdown } from 'flowbite-react'
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout'
import downloadIcon from '../../../assets/document-download.png'
import filterIcon from '../../../assets/filterIcon.png'
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import modalIcon from '../../../assets/shareholdersIcon.png'
import client from '../../../api/client'
import AddProductModal from './AddProductModal'
import { ColumnProducts, ProductsData } from '../../../types/TablesTypes/Products'
import showToast from '../../../components/CustomToast/toastHelper'
import { numberWithCommas } from '../../../utils/formatNumber'
import StatusView from '../../../components/StatusView/StatusView'

const Products = () => {
    const [filters, setFilters] = useState({
        toDate: "",
        fromDate: "",
        availability: "true"
    })
    const [products, setProducts] = useState<any>()
    const [tableRow, setTableRow]= useState<any[]>([])
    const [bearer, setBearer] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)

    const handleFilterChange = (filterName: string, value: string) => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            await fetchProducts();
        };
        fetchData();
    }, [filters, bearer]);

    const fetchProducts = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/product/all';
            const params = new URLSearchParams(filters).toString();
            const response = await client.get(`${apiUrl}?${params}`);
            console.log(response);

            setProducts(response.data.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const dataProducts = () => {    
        const tempArr: ProductsData[] = [];
		products?.items
			?.slice(0)
			.reverse()
			.forEach((product: any, index: number) => {
				 
				tempArr.push({
					productName: product?.name,
					price: `NGN ${numberWithCommas(product?.price)}`,
					availability: (
						<StatusView
							status={product?.availability}
							green='In-stock'
							red='Out-of-stock'
						/>
					),
					stockCount: product?.stock,
					sold: product?.total_orders,
					revenue: `NGN ${numberWithCommas(product?.totalAmount)}`,
					action: (
						<Dropdown label={
                            <FaEllipsisH/>
                        } inline arrowIcon={false} placement='right-start'>
                            
                        </Dropdown>
					),
				});
			});
		return tempArr;
    };

    useEffect(() => {
        const fetch=async()=>{
            setTableRow(await dataProducts());
        }
        fetch()
    }, [products?.items]);
    return (

        <DashboardPagesTemplate title='Products'
            apiUrl='/subsidiary/dashboard/product/all'
            show={showModal}
            openModal={()=>setShowModal(true)}
            closeModal={()=>setShowModal(false)}
            onFilterChange={setFilters} 
            data={tableRow ? tableRow : []}
            filters={filters} children={<AddProductModal onClose={()=>setShowModal(false)} onSuccess={fetchProducts}/>}
            modalIcon={modalIcon}
            exportButtonExists={false} dropdownItems={["Active", "Inactive"]}
            buttonLabel='Add New Product' buttonIcon={<FaPlusCircle />}
            headings={ColumnProducts} showSearch={false} ctaButtonExists={true} 
            emptyMessage='You do not have any products yet'/>

    )
}

export default Products
